export default "__VITE_ASSET__DiZz24FA__"